module.exports = "<ngx-loading [show]=\"loading\" ></ngx-loading>\n<router-outlet></router-outlet>"